import React, { useContext } from 'react';
import { StyleContext } from '@theme/AppStyles';
interface PropsT {
  size?: number;
}

const IconVideo = ({
    size = 24,
  }: PropsT) => {
  const [style] = useContext(StyleContext);
  const color = (style.name === "dark") ? "white" : "black";
  const colorHighlight = style.palette.accentPrimary;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect stroke={color} strokeMiterlimit={10} strokeWidth={2} x="1" y="2" width="22" height="18" rx="1.6" ry="1.6" />
      <path fill={colorHighlight}
            d="M16.8,10.3l-7.6-4.6c-.5-.3-1.2,0-1.2.7v9.1c0,.6.7,1,1.2.7l7.6-4.6c.5-.3.5-1.1,0-1.4Z" />
      <rect fill={color} x="7" y="21" width="10" height="2" rx="1" ry="1" />
    </svg>
  )
}

export default IconVideo;